export default __webpack_public_path__ + "static/media/person.dde45491.svg";